import React from 'react';
import PropTypes from 'prop-types';
import IconBox from './IconBox';
import './IconBoxRow.scss';

const propTypes = {
    boxes: PropTypes.array,
};

export default class IconBoxRow extends React.Component {
    constructor (props) {
        super(props);
    }

    render() {

        const {boxes} = this.props;

        return (
            <section className={`anim-boxes-holder`}>
                {this.props.boxes.map((b, index) => (
                    <IconBox key={index} box={b}/>
                ))}
            </section>
        )
    }
}

IconBoxRow.propTypes = propTypes;


// WEBPACK FOOTER //
// ./src/components/IconBoxRow/index.js